import styled from '@emotion/styled'
import { breakpoint, calcRem } from '../../../__styling'
import { AppContentSection } from "../../components/StyledAppContentSection.styled"


export const AppDownloadContentSectionMiddle = styled(AppContentSection)(({ theme }) => ({
    width: "100%",

    [breakpoint('sm')]: {
        width: "100%",
        padding: 0,
        flexDirection: 'row',
    },

    [breakpoint('xl')]: {
        width: theme.siteMetrics.mainContentWidth,
        padding: calcRem(0, 64),
    },
}))


export const AppDownloadSection = styled('div')({
    width: '100%',
    height: 'auto',

    zIndex: 1,
    position: 'relative',
})

export const AppDownloadImageSection = styled('div')({
    display: 'flex',
    position: 'relative',

    justifyContent: 'center',
    alignItems: 'end',

    width: '100%',
})

export const StyledAppDownloadImage = styled('img')({
    display: 'flex',
    position: 'relative',
    zIndex: 2,

    width: '100%',

    [breakpoint('sm')]: {
        width: "100%",
    },
})

export const StyledAppDownloadImageMobile = styled(StyledAppDownloadImage)({
    // Show Mobile image on mobile devices
    display: 'block',
    width: "100%",

    // Hide on Tablet or Larger
    [breakpoint('sm')]: {
        display: 'none',
    },
})

export const StyledAppDownloadImageTablet = styled(StyledAppDownloadImage)({
    // Hide on mobile
    display: 'none',

    // Show on Tablet
    [breakpoint('sm')]: {
        display: 'block',
        width: "100%",
    },

    // Hide on Desktop
    [breakpoint('xl')]: {
        display: 'none',
    },
})


export const StyledAppDownloadImageWeb = styled(StyledAppDownloadImage)({
    // Hide on Mobile
    display: 'none',

    // Hide on Tablet or Larger
    [breakpoint('sm')]: {
        display: 'none',
    },

    // Show full image on screens larger than tablets
    [breakpoint('xl')]: {
        display: 'block',
        width: "100%",
    },
})
